module.exports = __webpack_public_path__ + "img/arms-on-bg6.0706bb30.png";